// 	export default  [
// 	{ icon:'business', title: "办公业务",value: "办公业务",icon:'../../static/logo/tabarIndexLogo/business.png'},
// 	{ icon:'other', title: "其他",value: "其他",icon:'../../static/logo/tabarIndexLogo/other.png'},
// 	{ icon:'LeadershipView', title: "领导视图",value: "领导视图",icon:'../../static/logo/tabarIndexLogo/LeadershipView.png'}
// // ]

export default [
	{
		"busDate": "",
		"clinicId": 0,
		"costAmt": 0,
		"createId": 0,
		"createTime": "",
		"docNum": "",
		"id": 0,
		"list": [
			{
				"clinicId": 0,
				"drugId": '',
				"drugName": "",
				"drugSpec": "",
				"id": 0,
				"invId": 0,
				"manuLotnum": "",
				"nullifyCnt": 0,
				"nullifyDocId": 0,
				"nullifyId": 0,
				"nullifyState": 0,
				"nullifyTime": "",
				"nullifyWaitCnt": 0,
				"pacCnt": 0,
				"prodentpName": "",
				"prodentpNameId": '',
				"purcType": "",
				"retnAmt": '',
				"retnCnt": 0,
				"retnId": 0,
				"retnPric": '',
				"saleAmt": '',
				"salePric": '',
				"unt": ""
			}
		],
		"nullifyB": '',
		"nullifyId": '',
		"nullifyTime": "",
		"passingOrdersId": 0,
		"passingOrdersTime": "",
		"phayId": 4,
		"remarks": "",
		"retnTypeId": 5,
		"reviewId": '',
		"reviewTime": "",
		"saleAmt": '',
		"state": '',
		"supplyCandidateId": '',
		"terminalId": ""
	}
]

